import { useState } from 'react'
import { useSelector } from 'react-redux'
import TableMui from 'src/components/TableMui'
import { formatDatePlusThree } from 'src/utils/formatDate'
import { selectInventoryList } from '../../InventorySelector'
import { InventoryStatus } from '../../InventoryTypes'
import { FormInventoryList } from '../FormInventoryList/FormInventoryList'
import { InventoryDetailList } from '../InventoryDetail/InventoryDetailList'
import ModalCancelInventory from '../ModalCancelInventory'
import * as S from './TableInventoryLists.styles'

interface Props {
    clickCreate: boolean
    setClickCreate: (value: boolean) => void
    clickBadges: boolean
    setClickBadges: (value: boolean) => void
    clickInventoryDetail: boolean
    setClickInventoryDetail: (value: boolean) => void
}

export const TableInventoryLists = ({
  clickCreate, setClickCreate, clickBadges, setClickBadges, clickInventoryDetail, setClickInventoryDetail,
}: Props) => {
  const [openModalCancel, setOpenModalCancel] = useState(false)
  const [idForCancel, setIdForCancel] = useState()
  const inventoryList = useSelector(selectInventoryList)
  const [inventoryDetailList, setInventoryDetailList] = useState({
    id: 0,
    inventoryName: '',
    createdAt: new Date(),
    currentStatus: InventoryStatus.CREATED,
    percentageExecution: 0,
    skusQty: 0,
    percentageAccuracy: 0,
    countType: '',
  })

  const goToInventoryDetail = (inventory) => {
    setClickInventoryDetail(true)
    setInventoryDetailList(inventory)
  }

  const onClickCancelInventory = (id) => {
    setIdForCancel(id)
    setOpenModalCancel(true)
  }

  if (clickInventoryDetail) {
    return <InventoryDetailList inventory={inventoryDetailList} setClickInventoryDetail={setClickInventoryDetail} />
  }

  const tableRows = inventoryList?.map((i) => ({
    ...i,
    percentageExecution: i.percentageExecution === 0 ? '0' : i.percentageExecution,
    percentageAccuracy: i.percentageAccuracy === 0 ? '0' : i.percentageAccuracy,
    createdAt: formatDatePlusThree(i.createdAt),
    details: <S.InfoButton size={20} data-testid='detail-inventory-test' onClick={() => goToInventoryDetail(i)} />,
    cancel: <S.CustomButton
      title='Cancelar'
      bgColor='lightRed'
      hoverColor='cancelHover'
      letterColor='white'
      data-testid='cancel-inventory-button-test'
      id='cancel-inventory-button'
      onClick={() => onClickCancelInventory(i.id)}
      disabled={i.currentStatus === 'Cancelado' || i.currentStatus === 'Finalizado'}
    />,
  }))

  return (
    <S.Wrapper>
      <FormInventoryList
        clickCreate={clickCreate}
        setClickCreate={setClickCreate}
        clickBadges={clickBadges}
        setClickBadges={setClickBadges}
      />
      {!clickCreate && !clickBadges ? (
        <TableMui
          columns={[
            { id: 'inventoryName', label: 'Nome do inventário' },
            { id: 'createdAt', label: 'Data de criação' },
            { id: 'currentStatus', label: 'Status' },
            { id: 'percentageExecution', label: '%' },
            { id: 'skusQty', label: 'Qtd. de SKUs' },
            { id: 'percentageAccuracy', label: '% acuracidade' },
            { id: 'countType', label: 'Tipo' },
            { id: 'details', label: 'Detalhes' },
            { id: 'cancel', label: 'Cancelar' },
          ]}
          emptyLabel='Nenhuma lista de inventário gerada'
          rows={tableRows}
          enablePagination
          rowsPerPageLimit={10}
        />
      ) : <></>}
      <ModalCancelInventory
        open={openModalCancel}
        setOpen={setOpenModalCancel}
        idForCancel={idForCancel}
      />
    </S.Wrapper>
  )
}
